import { clone } from 'ramda';

import { resetTerms, setTerm } from '@/packages/JsonQuery/helpers';
import { EInfrastructure, type NonEmptyArray, type TJsonQuery } from '@/packages/JsonQuery/types';

export function setInfrastructureTypes(jsonQuery: TJsonQuery) {
  return (infrastructureTypes: NonEmptyArray<EInfrastructure> | null): TJsonQuery => {
    let nextJsonQuery = clone(jsonQuery);

    nextJsonQuery = resetTerms([
      'infrastructure_has_car_wash',
      'infrastructure_has_car_service',
      'infrastructure_has_pharmacy',
      'infrastructure_has_clothes_studio',
      'infrastructure_has_atm',
      'infrastructure_has_pool',
      'infrastructure_has_buffet',
      'infrastructure_has_exhibition_and_warehouse_complex',
      'infrastructure_has_hotel',
      'infrastructure_has_cafe',
      'infrastructure_has_cinema',
      'infrastructure_has_conference_room',
      'infrastructure_has_medical_center',
      'infrastructure_has_minimarket',
      'infrastructure_has_notary_office',
      'infrastructure_has_bank_department',
      'infrastructure_has_park',
      'infrastructure_has_restaurant',
      'infrastructure_has_beauty_shop',
      'infrastructure_has_warehouse',
      'infrastructure_has_canteen',
      'infrastructure_has_supermarket',
      'infrastructure_has_shopping_area',
      'infrastructure_has_fitness_centre',
      'infrastructure_has_studio',
      'infrastructure_has_central_reception',
    ])(nextJsonQuery);

    if (infrastructureTypes) {
      if (infrastructureTypes.includes(EInfrastructure.CarWash)) {
        nextJsonQuery = setTerm('infrastructure_has_car_wash')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.CarService)) {
        nextJsonQuery = setTerm('infrastructure_has_car_service')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.Pharmacy)) {
        nextJsonQuery = setTerm('infrastructure_has_pharmacy')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.ClothesStudio)) {
        nextJsonQuery = setTerm('infrastructure_has_clothes_studio')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.ATM)) {
        nextJsonQuery = setTerm('infrastructure_has_atm')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.Pool)) {
        nextJsonQuery = setTerm('infrastructure_has_pool')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.Buffet)) {
        nextJsonQuery = setTerm('infrastructure_has_buffet')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.WarehouseComplex)) {
        nextJsonQuery = setTerm('infrastructure_has_exhibition_and_warehouse_complex')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.Hotel)) {
        nextJsonQuery = setTerm('infrastructure_has_hotel')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.Cafe)) {
        nextJsonQuery = setTerm('infrastructure_has_cafe')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.Cinema)) {
        nextJsonQuery = setTerm('infrastructure_has_cinema')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.ConferenceRoom)) {
        nextJsonQuery = setTerm('infrastructure_has_conference_room')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.MedicalCenter)) {
        nextJsonQuery = setTerm('infrastructure_has_medical_center')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.Minimarket)) {
        nextJsonQuery = setTerm('infrastructure_has_minimarket')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.NotaryOffice)) {
        nextJsonQuery = setTerm('infrastructure_has_notary_office')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.BankDepartment)) {
        nextJsonQuery = setTerm('infrastructure_has_bank_department')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.Park)) {
        nextJsonQuery = setTerm('infrastructure_has_park')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.Restaurant)) {
        nextJsonQuery = setTerm('infrastructure_has_restaurant')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.BeautyShop)) {
        nextJsonQuery = setTerm('infrastructure_has_beauty_shop')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.Warehouse)) {
        nextJsonQuery = setTerm('infrastructure_has_warehouse')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.Canteen)) {
        nextJsonQuery = setTerm('infrastructure_has_canteen')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.Supermarket)) {
        nextJsonQuery = setTerm('infrastructure_has_supermarket')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.ShoppingArea)) {
        nextJsonQuery = setTerm('infrastructure_has_shopping_area')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.FitnessCentre)) {
        nextJsonQuery = setTerm('infrastructure_has_fitness_centre')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.Studio)) {
        nextJsonQuery = setTerm('infrastructure_has_studio')(nextJsonQuery)(true);
      }

      if (infrastructureTypes.includes(EInfrastructure.CentralReception)) {
        nextJsonQuery = setTerm('infrastructure_has_central_reception')(nextJsonQuery)(true);
      }
    }

    return nextJsonQuery;
  };
}
